module.exports = __webpack_public_path__ + "img/adial.be694c3b.jpg";